module.exports = __webpack_public_path__ + "img/chinesecompany167.722d1b24.png";